import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { Text } from 'src/Components'
import styles from './StateSpecificFooterLinks.module.scss'
import everyStateIabsPdf from 'src/assets/compliance/everyStateIABS.pdf'
import classNames from 'classnames'

interface StateSpecificFooterLinksProps {
  align: 'left' | 'center'
}

export const StateSpecificFooterLinks = ({
  align,
}: StateSpecificFooterLinksProps) => {
  return (
    <div
      className={classNames(
        styles.container,
        align === 'left' && styles.alignLeft,
        align === 'center' && styles.alignCenter
      )}
    >
      <Text element='div' size='m' variant='neutralCool' variantCount='700'>
        California DRE #02109231
      </Text>
      <div
        className={classNames(
          styles.trecSection,
          align === 'left' && styles.justifyLeft,
          align === 'center' && styles.justifyCenter
        )}
      >
        <Text
          className={styles.trecText}
          element='span'
          size='m'
          variant='neutralCool'
          variantCount='700'
        >
          TREC:
        </Text>
        &nbsp;
        <Link to={everyStateIabsPdf} target='_blank' rel='noreferrer'>
          <FormattedMessage
            id='HomeSearch.compliance.trecIabs'
            defaultMessage='Info About Brokerage Services'
          />
        </Link>
        {','}
        &nbsp;
        <Link
          to={{
            pathname:
              'https://www.trec.texas.gov/forms/consumer-protection-notice',
          }}
          target='_blank'
        >
          <FormattedMessage
            id='HomeSearch.compliance.trecConsumerProtectionNotice'
            defaultMessage='Consumer Protection Notice'
          />
        </Link>
      </div>
    </div>
  )
}
